(function ($) {
    $(() => {
        $('.name-validation').keydown(e => {
            // Allow: backspace, delete, tab, escape, enter and .
            if (
                $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                e.key === '+' ||
                // Allow: home, end, left, right, down, up
                (e.keyCode >= 35 && e.keyCode <= 40)
            ) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is char [a-zA-Z] or space, ', é,í,ó,ö,ő,ú,ü,ű
            if (
                (e.keyCode < 64 || e.keyCode > 90) &&
                (e.keyCode !== 32 &&
                    e.key !== "'" &&
                    e.keyCode !== 222 &&
                    e.keyCode !== 186 &&
                    e.keyCode !== 226 &&
                    e.keyCode !== 187 &&
                    e.keyCode !== 192 &&
                    e.keyCode !== 219 &&
                    e.keyCode !== 221 &&
                    e.keyCode !== 191 &&
                    e.keyCode !== 220)
            ) {
                e.preventDefault();
            }
        });

        function namevalidation(inputtxt) {
            var regexp = /(^[a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ]+[ ][a-zA-Z áéíóöőúüűÁÉÍÓÖŐÚÜŰ]+)\w+/gm;
            if (inputtxt.match(regexp)) {
                return true;
            } else {
                return false;
            }
        }

        $('.counter-p').html('0/500');

        $('#suggest-message').keyup(() => {
            const text_length = $('#suggest-message').val().length;
            const text_remaining = text_length;

            $('.counter-p').html(`${text_remaining}/500`);
        });

        $('.js-suggest-form').parsley({
            trigger: 'change',
            successClass: 'is-success',
            errorClass: 'is-error',
            classHandler(el) {
                return el.$element.closest('.input-wrapper-col');
            },
            errorsWrapper: '<div class="invalid-message"></div>',
            errorTemplate: '<span></span>'
        });

        let addedFilesCounter_suggest = 0;

        const $suggest_select = $('#select-suggest').selectize({
            sortField: 'text',
            onDropdownOpen: function () {
                $('.selectize-dropdown').addClass('bordered');
            },
            onDropdownClose: function () {
                $('.selectize-dropdown').removeClass('bordered');
            }
        });

        function resetSuggestForm() {
            $('.suggest-form').trigger('reset');
            $("input[name='uploaded_files_json']").val('');
            addedFilesCounter_suggest = 0;
            $('#files-suggest div').each(function () {
                $(this).remove();
            });
            $('.suggest-select').val('');
            /*   const control = $suggest_select[0].selectize;
            control.clear(); */
            $('.form-wrapper').hide();
            $('.kotelezo').addClass('hide');
            $('.success-section').show();
        }

        $('.error-btn').on('click', e => {
            e.preventDefault();
            $('.error-section').hide();
            $('.form-wrapper, .kotelezo').show();
        });

        // Initialize the jQuery File Upload widget for Join Form
        $('#fileinput-suggest').fileupload({
            url: ajax.ajaxurl,
            dataType: 'json',
            autoUpload: false,
            add(e, data) {
                const fileSize = data.originalFiles[0].size;
                const fileType = data.originalFiles[0].type;

                if (addedFilesCounter_suggest >= 3) {
                    swal({
                        title: ajax.translations.csak_1_fajl,
                        text: '',
                        icon: 'error',
                        confirmButtonClass: 'btn btn-primary-cutted-corner btn-primary-neon m-0',
                        buttonsStyling: false
                    });
                } else if (fileSize > 2222000000) {
                    swal({
                        title: ajax.translations.tul_nagy,
                        text: '',
                        icon: 'error'
                    });
                } else if (fileType !== 'image/jpeg' && fileType !== 'image/png') {
                    swal({
                        title: ajax.translations.file_format,
                        text: '',
                        icon: 'error'
                    });
                } else {
                    addedFilesCounter_suggest++;
                    data.submit();
                }
            },
            done(e, response) {
                if (response.result.success === true && response.result.data.status == 'ok') {
                    const file = response.result.data.file;

                    const file_url = file.url;
                    const arr = file_url.split('/');
                    const img = arr[arr.length - 1];

                    const file_name = file.name;
                    let short_file_name = file_name;
                    if (file_name.length > 18) short_file_name = `${file_name.substring(0, 18)}...`;
                    // $('#files-suggest').fadeIn().append('<h6 data-file_name="' + file.url + '">' + file.url + '<i class="delete-icon fa fa-trash-alt" aria-hidden="true"></i></h6>');
                    $('#files-suggest')
                        .fadeIn()
                        .append(
                            `<div class="upload-img" data-file_name="${file.url}"><img src="${ajax.themeurl
                            }/uploads/${img}" alt="img"><span class="delete-icon">+</span></div>`
                        );
                } else {
                    swal({
                        title: response.result.data.title,
                        text: '',
                        icon: 'error'
                    });
                }
            }
        });

        $(document).on('click', '.delete-icon', function () {
            $(this)
                .parent()
                .remove();
            addedFilesCounter_suggest--;
        });

        // join
        $('.suggest-form').on('submit', function (e) {
            e.preventDefault();
            const $this = $(this);

            const name_string = $('#suggest-name').val();

            if (!namevalidation(name_string)) {
                $('.name-error-wrapper').show();
            } else if ($('.selectize-input').hasClass('not-full')) {
                $('.error-select-wrapper').addClass('show');
            } else if (
                $('.suggest-check').prop('checked') &&
                addedFilesCounter_suggest >= 1 &&
                addedFilesCounter_suggest <= 3 &&
                $('#suggest-message').val().length >= 50
            ) {
                $(this)
                    .find('.suggest-btn')
                    .prop('disabled', true);

                const $input_fn = $('input[name=uploaded_files_json]');
                $input_fn.val('');

                $('#files-suggest div').each((i, element) => {
                    $input_fn.val(`${$input_fn.val() + $(element).data('file_name')} | `);
                });

                const formdata = $this.serializeArray();
                /* formdata[formdata.length] = {
                        name: 'recaptcha',
                        value: $(this).find('#g-recaptcha-response').val()
                    }; */
                $.ajax({
                    url: ajax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'suggest_form',
                        datas: formdata
                    },
                    success(data) {
                        const result = JSON.parse(data);

                        // grecaptcha.reset();
                        if (result.status == 'success') {
                            resetSuggestForm();
                        } else {
                            $('.form-wrapper').hide();
                            $('.kotelezo').addClass('hide');
                            $('.error-section').show();
                        }
                    }
                }).done(response => {
                    $this.find('.suggest-btn').prop('disabled', false);
                });
            } else {
                if (addedFilesCounter_suggest === 0) {
                    $('.custom-file-label').addClass('file-error');
                    swal({
                        title: ajax.translations.kotelezo_fajl,
                        text: '',
                        icon: 'error',
                        button: ajax.translations.ok
                    });
                }

                if (!$('.suggest-check').prop('checked')) {
                    $('.error-check-wrapper').addClass('show');
                }

                if ($('#suggest-message').val().length < 50) {
                    $('.textarea-error-wrapper').addClass('show');
                }
            }
        });

        $('.suggest-check').change(() => {
            $('.error-check-wrapper').removeClass('show');
        });

        $('#suggest-message').keyup(() => {
            if ($('#suggest-message').val().length >= 50) {
                $('.textarea-error-wrapper').removeClass('show');
            }
        });

        $('#suggest-name').keyup(function () {
            $('.name-error-wrapper').hide();
        });
    });
})(jQuery);
